import { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import { Modal, Typography, TextField, Button } from "@mui/material";
import ModalBox from "../themes/overrides/ModalBox";
import { getContentTypeById, updateContentType } from "../actions/contentActions";
import { useDispatch, useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import { getContentTypeForEntry } from "../actions/entryActions";

const AiEditPromptModal = ({ open, onClose, selectedField, editContentTypeId }) => {
    const { workspaceId, id } = useParams();
    const [prompt, setPrompt] = useState("");
    const dispatch = useDispatch();
    const location = useLocation();
    const contentData = useSelector((state) => state.form);
    const [contentTypeId, setContentTypeId] = useState(null);

    useEffect(() => {
        const newContentTypeId = location.pathname.includes('/edit-entry') ? editContentTypeId : id;
        if (newContentTypeId) {
            setContentTypeId(newContentTypeId);
        }
    }, [id, editContentTypeId, location.pathname]);

    // Fetch data when contentTypeId is set
    useEffect(() => {
        if (contentTypeId) {
            dispatch(getContentTypeById(workspaceId, contentTypeId));
        }
    }, [open, contentTypeId, dispatch, workspaceId]);


    useEffect(() => {
        setPrompt(selectedField?.ai_prompt ?? "");
    }, [selectedField]);


    // Handle save button click
    const handleSave = async () => {

        // Update only the specific field's ai_prompt inside the fields array
        const updatedFields = contentData?.fields?.map((field) =>
            field.id === selectedField.id ? { ...field, ai_prompt: prompt } : field
        );

        const formData = {
            fields: updatedFields,
        };

        await dispatch(updateContentType(contentTypeId, formData))
        onClose(); // Close modal
        dispatch(getContentTypeForEntry(workspaceId, contentTypeId))
    };

    return (
        <Modal open={open} onClose={onClose}>
            <ModalBox sx={{ width: '700px', maxWidth: '95%' }}>
                <Typography variant="h6" id="modal-title" sx={{ mb: 3 }}>
                    Edit AI Prompt for this field.
                </Typography>

                <TextField
                    fullWidth
                    multiline
                    minRows={3}
                    value={prompt}
                    onChange={(e) => setPrompt(e.target.value)}
                    variant="outlined"
                    label="AI Prompt"
                />

                <div style={{ display: "flex", justifyContent: "flex-end", marginTop: "16px" }}>
                    <Button onClick={onClose} variant="outlined" color="secondary" sx={{ marginRight: "8px" }}>
                        Cancel
                    </Button>
                    <Button onClick={handleSave} variant="contained" color="primary">
                        Save
                    </Button>
                </div>
            </ModalBox>
        </Modal>
    );
};

export default AiEditPromptModal;